import { SelectSearcher } from "../../../../_components/Abstractions/MultiSearcher/SelectSearcher";
import { useSalesRepresentativeSearch } from "./SalesRepresentativeSearcher";

export function SalesRepresentativeSelect({ name }) {
  const { items, onSearchChange } = useSalesRepresentativeSearch();

  return (
    <>
      <SelectSearcher
        name={name}
        items={items}
        onSearchChange={onSearchChange}
        optionsObject={{ key: "id", value: "name" }}
        label="Przedstawiciel handlowy"
        saveWholeObject
      />
    </>
  );
}

